import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import fr from 'date-fns/locale/fr';
import type { PeriodFilter as PeriodFilterType } from '../types/rdv';

interface PeriodFilterProps {
  period: PeriodFilterType;
  onPeriodChange: (period: PeriodFilterType) => void;
  startDate: Date | null;
  endDate: Date | null;
  onDateChange: (start: Date | null, end: Date | null) => void;
}

const PeriodFilter: React.FC<PeriodFilterProps> = ({
  period,
  onPeriodChange,
  startDate,
  endDate,
  onDateChange,
}) => {
  return (
    <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
      <ToggleButtonGroup
        value={period}
        exclusive
        onChange={(_, newPeriod) => {
          if (newPeriod) {
            onPeriodChange(newPeriod as PeriodFilterType);
            if (newPeriod !== 'personnalise') {
              onDateChange(null, null);
            }
          }
        }}
        aria-label="période"
        size="small"
      >
        <ToggleButton value="tous">Tous</ToggleButton>
        <ToggleButton value="jour">Jour en cours</ToggleButton>
        <ToggleButton value="semaine">Semaine en cours</ToggleButton>
        <ToggleButton value="mois">Mois en cours</ToggleButton>
        <ToggleButton value="personnalise">Personnalisé</ToggleButton>
      </ToggleButtonGroup>

      {period === 'personnalise' && (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <DatePicker
              label="Date de début"
              value={startDate}
              onChange={(newValue: Date | null) => onDateChange(newValue, endDate)}
              slotProps={{ textField: { size: 'small' } }}
            />
            <DatePicker
              label="Date de fin"
              value={endDate}
              onChange={(newValue: Date | null) => onDateChange(startDate, newValue)}
              slotProps={{ textField: { size: 'small' } }}
              minDate={startDate || undefined}
            />
          </Box>
        </LocalizationProvider>
      )}
    </Box>
  );
};

export default PeriodFilter; 